/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Copy_SkuInputs */

const en_endpoint_copy_sku = /** @type {(inputs: Endpoint_Copy_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy SKU`)
};

const zh_hans1_endpoint_copy_sku = /** @type {(inputs: Endpoint_Copy_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制 SKU`)
};

const pt_br2_endpoint_copy_sku = /** @type {(inputs: Endpoint_Copy_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar SKU`)
};

const es_endpoint_copy_sku = /** @type {(inputs: Endpoint_Copy_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar SKU`)
};

const fr_endpoint_copy_sku = /** @type {(inputs: Endpoint_Copy_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier le SKU`)
};

const de_endpoint_copy_sku = /** @type {(inputs: Endpoint_Copy_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SKU kopieren`)
};

const ru_endpoint_copy_sku = /** @type {(inputs: Endpoint_Copy_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать SKU`)
};

const it_endpoint_copy_sku = /** @type {(inputs: Endpoint_Copy_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia SKU`)
};

/**
* | output |
* | --- |
* | "Copy SKU" |
*
* @param {Endpoint_Copy_SkuInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_copy_sku = /** @type {((inputs?: Endpoint_Copy_SkuInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Copy_SkuInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_copy_sku(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_copy_sku(inputs)
	if (locale === "es") return es_endpoint_copy_sku(inputs)
	if (locale === "fr") return fr_endpoint_copy_sku(inputs)
	if (locale === "de") return de_endpoint_copy_sku(inputs)
	if (locale === "ru") return ru_endpoint_copy_sku(inputs)
	if (locale === "it") return it_endpoint_copy_sku(inputs)
	return en_endpoint_copy_sku(inputs)
});